export enum GateKind {
  Digipa = 'digipa',
  Digili = 'digili',
  Kyc = 'kyc',
}
